<template>
  <div>
    <v-toolbar card color="white">
      <v-toolbar-title>Admin Tool</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        solo
        hide-details
        prepend-inner-icon="search"
        placeholder="Tìm trên danh sách này"
        v-model="keyword"
      ></v-text-field>
      <v-tooltip bottom>
        <v-btn icon slot="activator" @click="exportToExcel()">
          <v-icon>save_alt</v-icon>
        </v-btn>
        <span>Tải về</span>
      </v-tooltip>
    </v-toolbar>
    <v-divider></v-divider>
    <v-data-table
      item-key="id"
      :headers="table.headers"
      :items="datasourceFiltered"
      :rows-per-page-items="[10,20,50,100]"
      :loading="isLoading"
    >
      <template slot="items" slot-scope="props">
        <tr :class="getRowColor(props.item)">
          <td>{{ props.item.TrackingId}}</td>
          <td class="no-wrap">{{ props.item.Plate}}</td>
          <td>{{ props.item.UnitId }}</td>
          <td>{{ props.item.SN }}</td>
          <td>{{ props.item.Code }}</td>
          <td>{{ props.item.SIMID}}</td>
          <td>{{ props.item.IMEI}}</td>
          <td class="no-wrap">{{ props.item.FW}}</td>
          <td class="no-wrap">{{ formatSecondToGPSTime(props.item.GpsTime)}}</td>
          <td>{{ props.item.Sat}}</td>
          <td>{{ props.item.Speed }}</td>
          <td>
            <a target="_blank" :href="getLatLonUrl(props.item.LatLon)">{{ props.item.LatLon }}</a>
          </td>
          <td>{{ props.item.BAUDRATE }}</td>
          <td>{{ props.item.Sensors }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import validate from '@/utils/validate';
import * as DateTimeUtil from '@/utils/datetime';
import XLSX from 'xlsx';

export default {
  props: {
    name: String,
    vehicles: Array,
    devices: Array
  },
  data () {
    return {
      table: {
        headers: [
          {
            text: 'TrackingId',
            value: 'TrackingId'
          },
          {
            text: 'Plate',
            value: 'Plate'
          },
          {
            text: 'UnitId',
            value: 'UnitId'
          },
          {
            text: 'SN',
            value: 'SN'
          },
          {
            text: 'Code',
            value: 'Code'
          },
          {
            text: 'SimId',
            value: 'SIMID'
          },
          {
            text: 'Imei',
            value: 'IMEI'
          },
          {
            text: 'Firmware',
            value: 'FW'
          },
          {
            text: 'GpsTime',
            value: 'GpsTime'
          },
          {
            text: 'Sattelite',
            value: 'Sat'
          },
          {
            text: 'Speed',
            value: 'Speed'
          },
          {
            text: 'LatLon',
            value: 'LatLon'
          },
          {
            text: 'Baudrate',
            value: 'BAUDRATE'
          },
          {
            text: 'Sensors',
            value: 'Sensors'
          }
        ]
      },
      isLoading: false,
      keyword: '',
      datasource: [],
      datasourceFiltered: []
    };
  },
  computed: {
    ...mapGetters(['searchText'])
  },
  watch: {
    keyword () {
      this.search();
    }
  },
  created () {
    this.getAdminToolStatuses();
  },
  methods: {
    ...mapActions(['GetVehiclesSettingRequest', 'VehiclesRequest']),

    getAdminToolStatuses () {
      if (this.vehicles.length < 1) {
        return;
      }

      this.datasource = [];
      this.datasourceFiltered = [];
      this.isLoading = true;

      let Ids = this.vehicles.map(a => a.Id);

      let data = [];
      let infoPart1 = [];
      let infoPart2 = [];

      this.GetVehiclesSettingRequest({ Ids })
        .then(res1 => {
          infoPart1 = res1;

          this.VehiclesRequest({ Ids, Raw: false })
            .then(res2 => {
              infoPart2 = res2;
            })
            .finally(_ => {
              for (let index = 0; index < this.vehicles.length; index++) {
                let vehicle = this.vehicles[index];

                let v1 = infoPart1.filter(a => a.Id === vehicle.Id)[0];
                if (v1) {
                  vehicle = { ...vehicle, ...v1 };
                  if (v1.Data.length > 0) {
                    for (let i = 0; i < v1.Data.length; i++) {
                      let element = v1.Data[i];
                      vehicle[validate.transferVietnamese(element.K)] =
                        element.V;
                    }
                  }
                }

                let v2 = infoPart2.filter(a => a.VehicleId === vehicle.Id)[0];
                if (v2) {
                  vehicle = { ...vehicle, ...v2 };
                  if (v2.DataParsed.length > 0) {
                    for (let i = 0; i < v2.DataParsed.length; i++) {
                      let element = v2.DataParsed[i];
                      let arr = element.trim().split(':');
                      if (arr.length > 1) {
                        let key = validate.transferVietnamese(arr[0]);
                        let value = arr[1];
                        vehicle[key] = value;
                      }
                    }
                  }
                }

                let v3 = this.devices.filter(a => a.Id === vehicle.DeviceId)[0];
                if (v3) {
                  vehicle['SN'] = v3.SN;
                  vehicle['Code'] = v3.Code;
                  vehicle['TrackingId'] = Number(vehicle.Id) * 256 + 16;
                }

                data.push(vehicle);
              }
              this.datasource = data;
              this.datasourceFiltered = data;
              if (!this.searchText.startsWith('/')) {
                this.keyword = this.searchText;
              }
            });
        })
        .catch(_ => {
          this.datasource = [];
          this.datasourceFiltered = [];
        })
        .finally(_ => {
          this.isLoading = false;
        });
    },

    formatSecondToGPSTime (time) {
      return DateTimeUtil.formatSecondToGPSTime(time);
    },

    getLatLonUrl: latlon =>
      (latlon ? `https://maps.google.com/?q=${latlon}` : ''),

    search () {
      let keywordRemovedVietnamese = validate.transferVietnamese(
        this.keyword.toLowerCase()
      );
      this.datasourceFiltered = this.datasource.filter(a =>
        validate
          .transferVietnamese((a.Plate || '').toLowerCase())
          .includes(keywordRemovedVietnamese.toLowerCase())
      );
    },

    exportToExcel () {
      if (this.datasourceFiltered.length === 0) {
        window.getApp.showMessage('Không có dữ liệu', 'error');
        return;
      }

      let sheet = XLSX.utils.json_to_sheet(this.datasourceFiltered);
      let wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, sheet, 'AdminTool');
      XLSX.writeFile(wb, `${this.name} - AdminTool.xlsx`);
    },

    getRowColor (item) {
      return item.Inactive
        ? 'inactive'
        : item.IsLocked
          ? 'islocked'
          : !(item.IMEI || item.UnitId)
            ? 'isvirtual'
            : 'none';
    }
  }
};
</script>

<style>
.inactive {
  background: #c1c1c1 !important;
}
.islocked {
  background: orange !important;
}
.isvirtual {
  background: yellow !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/search/components/AdminTool.vue